import type { I_PlatformHandlers } from '@/types/Platforms';
import { E_WidgetPlatform } from '@/types/Widget';

import { shopifyHandlers } from './shopify';

export const platformHandlers: Record<E_WidgetPlatform, I_PlatformHandlers> = {
  [E_WidgetPlatform.SHOPIFY]: shopifyHandlers,
  // NOTE: Later on we are going to add more platforms so we can add a new platform easily
};
